module.exports = __webpack_public_path__ + "media/images/ios-share-icon-15c3839a9b324d354eb53a5d22b67ff7.png";